import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Link from '@nubank/nuds-web/components/Link/Link';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Grid from '@nubank/nuds-web/components/Grid/Grid';
import Box from '@nubank/nuds-web/components/Box/Box';
import Image from '@nubank/nuds-web/components/Image/Image';
import { NuDsContext } from '@nubank/nuds-web/components/NuDSProvider/NuDSProvider';

function SectionKnowMore({ index }) {
  const { formatMessage } = useContext(NuDsContext);

  return (
    <Box
      tag="section"
      backgroundColor="white"
      paddingVertical={{ xs: '12x', md: '20x', lg: '32x' }}
    >
      <Grid
        paddingLeft={{ xs: '8x', md: '16x' }}
        paddingRight={{ xs: '8x', md: '16x' }}
        rowGap="12x"
        alignItems={{ lg: 'center' }}
      >
        <Grid.Child
          gridColumn={{ xs: '1 / span 4', md: '1 / span 6', lg: '8 / span 4' }}
        >
          <Typography
            variant="title"
            color="black"
            marginBottom="4x"
            intlKey={`cms.cardPage.cardCardsArea[${index}].cardSampleCardTitle`}
          />
          <Link
            href={formatMessage({ id: `cms.cardPage.cardCardsArea[${index}].cardSampleCardCtaLink` })}
            color="primary"
            intlKey={`cms.cardPage.cardCardsArea[${index}].cardSampleCardCtaText`}
            variant="action"
          />
        </Grid.Child>
        <Grid.Child
          gridColumn={{ xs: '1 / span 4', md: '2 / span 4', lg: '2 / span 5' }}
          gridRow={{ lg: '1' }}
        >
          <Image
            loading="lazy"
            srcSet={{
              xs: {
                '1x': 'app-screenshots/app-screenshots-xs@1x.jpg',
                '2x': 'app-screenshots/app-screenshots-xs@2x.jpg',
                '3x': 'app-screenshots/app-screenshots-xs@3x.jpg',
              },
              md: {
                '1x': 'app-screenshots/app-screenshots-md@1x.jpg',
                '2x': 'app-screenshots/app-screenshots-md@2x.jpg',
                '3x': 'app-screenshots/app-screenshots-md@3x.jpg',
              },
              lg: {
                '1x': 'app-screenshots/app-screenshots-lg@1x.jpg',
                '2x': 'app-screenshots/app-screenshots-lg@2x.jpg',
                '3x': 'app-screenshots/app-screenshots-lg@3x.jpg',
              },
            }}
            altIntlKey="CARD.KNOW_MORE.IMAGE_ALT"
          />
        </Grid.Child>
      </Grid>
    </Box>
  );
}

SectionKnowMore.propTypes = {
  index: PropTypes.number.isRequired,
};

export default React.memo(SectionKnowMore);
